import {
  forwardRef,
  type InputHTMLAttributes,
  type LabelHTMLAttributes,
  type ReactNode,
} from 'react';

import { cn } from '../../lib/utils.js';

export type RadioProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { className, ...props },
  ref,
) {
  return <input ref={ref} type="radio" className={cn('radio', className)} {...props} />;
});

export interface RadioRowProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
}

export function RadioRow({ children, className, ...props }: RadioRowProps) {
  return (
    <label className={cn('radio-row', className)} {...props}>
      {children}
    </label>
  );
}

export interface RadioGroupProps extends LabelHTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/** Horizontal cluster of {@link RadioRow} options — one option per row label, laid out inline. */
export function RadioGroup({ children, className, ...props }: RadioGroupProps) {
  return (
    <div className={cn('radio-group', className)} role="radiogroup" {...props}>
      {children}
    </div>
  );
}
